import React from 'react';
import { getUp, getUpKey, getTxt, mutStore, dispName, s3UploadHandler, OkFile, UpBtn, S3Row } from './stepcommon';
import { downloadUploadFile, openS3 } from './docgen';
import { mval } from './collect';
import type { Project } from './types';

interface Props {
  p: Project;
  onPatch: (patch: Partial<Project>) => void;
  toast: (m: string) => void;
}

export default function Step6({ p, onPatch, toast }: Props) {
  const gp = p.master ? p.master.gp : { name: '', tel: '', email: '' };
  const collected = p.collect ? mval(p.collect.gp, 'creditIdPw') : '';
  const manual = getTxt(p, 's6', 'creditIdPw');
  const creditVal = manual || collected;
  const setCredit = (v: string) => onPatch(mutStore(p, 's6', (st) => { st.txt = st.txt || {}; st.txt.creditIdPw = v; }));
  const up = (k: string, label: string, title: string, no: number) => {
    const cur = getUp(p, 's6', k);
    const disp = cur ? dispName(cur, title, p.org || '') : cur;
    const save = s3UploadHandler(p, 's6', k, onPatch, toast, title);
    return (
      <S3Row no={no} title={title} key={k}>
        {cur ? <OkFile name={disp} onPv={() => openS3(getUpKey(p, 's6', k), disp, true).catch((e) => toast((e as Error).message))} onDl={() => downloadUploadFile(p, getUpKey(p, 's6', k), disp, toast)} onRe={save} /> : <UpBtn label={label} onUp={save} />}
      </S3Row>
    );
  };
  return (
    <div className="sact">
      <div className="sact-h">📨 GP 정보 요청</div>
      <div className="s6send">
        <div className="s6info">GP 연락처 (정보요청 대상) · <b>{gp.name || '-'}</b>
          <span>📱 {gp.tel || '휴대폰 미입력'}{'\u00A0·\u00A0'}✉ {gp.email || '이메일 미입력'}</span>
        </div>
      </div>
      <div className="lbl" style={{ marginTop: 14 }}>GP 제출 서류 (3) · 직접 업로드</div>
      <div style={{ margin: '6px 0 10px' }}>
        <div className="s3muted" style={{ marginBottom: 4 }}>신용정보 조회사이트 ID/PW · 신용정보조회서 발급용{collected && !manual ? ' (자료수집 제출분 — 수정 시 덮어씀)' : ' (자료수집 미제출 시 직접 입력)'}</div>
        <div className="s3in"><input className="pp-in" value={creditVal} onChange={(e) => setCredit(e.target.value)} placeholder="신용정보 조회사이트 ID / PW" /></div>
        <div className="s3file" style={{ marginTop: 7 }}>
          <a className="upbtn link" href="https://www.credit4u.or.kr:2443/" target="_blank" rel="noopener noreferrer">🔗 신용정보 조회사이트 바로가기 (크레딧포유)</a>
          <span className="s3muted" style={{ marginLeft: 2 }}>credit4u.or.kr · 한국신용정보원 · 별도 탭</span>
        </div>
      </div>
      {up('credit', '신용정보조회서 업로드', 'GP 신용정보조회서', 1)}
      {up('capproof', '증빙서류 업로드', '출자내역 증빙서류', 2)}
      {up('balance', '잔고증명서 업로드', '조합통장 잔고증명서', 3)}
    </div>
  );
}
